import { lazyVue } from "@/utils";
export default [{
    path: '/commentDetail',
    name: 'commentDetail',
    title: '评价详情',
    component: lazyVue('commentDetail/index'),
    meta: {
        // showBar:1,
        title: '评价详情',
        name: '评价详情'
    }
}]


// WEBPACK FOOTER //
// ./src/router/commentDetail/index.js